export default __webpack_public_path__ + "static/media/ahaa-ribbon.66ea1b5b.png";